import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import PropTypes from 'prop-types';
import {
  useEffect,
  useRef,
  useState,
} from 'react';

import LeafletMapContext from './LeafletMapContext';

// center and zoom apply at creation only; moving the map afterwards is the map's own business
function LeafletMap(props) {
  const {
    children = null,
    className,
    style,
    whenReady,
    ...mapOptions
  } = props;
  const containerRef = useRef(null);
  const [map, setMap] = useState(null);

  useEffect(
    () => {
      const created = L.map(containerRef.current, mapOptions);
      if (whenReady) created.whenReady(whenReady);
      setMap(created);
      return () => {
        created.remove();
        setMap(null);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- creation-time options only
    [],
  );

  // Leaflet re-measures only on window resize, so a panel appearing beside it leaves a stale width
  useEffect(
    () => {
      if (!map) return undefined;
      const observer = new ResizeObserver(() => {
        map.invalidateSize({ animate: false });
      });
      observer.observe(containerRef.current);
      return () => {
        observer.disconnect();
      };
    },
    [map],
  );

  return (
    <div
      ref={containerRef}
      className={className}
      style={style}
    >
      {(map)
        ? (
            <LeafletMapContext.Provider value={map}>
              {children}
            </LeafletMapContext.Provider>
          )
        : null}
    </div>
  );
}

LeafletMap.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  center: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  ]),
  zoom: PropTypes.number,
  minZoom: PropTypes.number,
  maxZoom: PropTypes.number,
  whenReady: PropTypes.func,
};

export default LeafletMap;
